@import '~less/global-variables';

.faq-header {
  padding-top: 130px;
  padding-bottom: 50px;
  &.board-happyhippies {
    background-position: 50% 30%;
  }
  @media (min-width: @screen-sm-min) {
    padding-top: 260px;
    padding-bottom: 200px;
  }
}

#faq-sidebar.sidebar {
  margin-top: (20px + @navbar-height);
}

.faq-filter {
  margin-top: (20px + @navbar-height);
}

.faq-question {
  margin-top: 0;
  padding-top: (20px + @navbar-height);
  h3 {
    margin-top: 0;
    padding-top: 0;
    background-color: transparent;
  }
  &.faq-question-flash h3 {
    animation-name: faqFlash;
    animation-duration: 1000ms;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
  }
}

@keyframes faqFlash {
  from {
    background-color: lighten(@brand-secondary, 20%);
  }
  to {
    background-color: transparent;
  }
}
